module.exports = __webpack_public_path__ + "2e32a829c586b220e96d5a249bd25cd1.pdf";